import { SOFTWARE_PROJECT } from '@atlassian/jira-common-constants';
import { fg } from '@atlassian/jira-feature-gating';
import { useProjectContext } from '@atlassian/jira-providers-project-context';
import { FREE_EDITION } from '@atlassian/jira-shared-types';
import {
	useAppEditions,
	useFirstActivationDateMs,
} from '@atlassian/jira-tenant-context-controller';

export const useShouldApplyFeatureToggle = () => {
	const { data: project } = useProjectContext();
	const { software } = useAppEditions();
	const firstActivationDateMs = useFirstActivationDateMs() || 0;

	const isJSW = project?.projectType === SOFTWARE_PROJECT;
	const isTMP = !!project?.simplified;
	const isProjectAdmin = !!project?.isProjectAdmin;
	const isFreeInstance = software === FREE_EDITION;
	const isNewInstance = new Date(firstActivationDateMs) >= new Date('2023-09-25T15:00:00');

	if (fg('jsw_feature_toggle_project_pages')) {
		return isJSW && isTMP && isProjectAdmin && isNewInstance;
	}

	return isJSW && isFreeInstance && isTMP && isProjectAdmin && isNewInstance;
};
